class Callbacks {
  static filterToFormHandler(user, name) {
    return function filterToForm(filter) {
      return { user, name, ...filter }
    }
  }
}

export default Callbacks
